module.exports = __webpack_public_path__ + "img/yonazuku_face.98cc2291.svg";